"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _ChannelClient_protectedObj, _ChannelClient_strategy, _ChannelClient_close;
Object.defineProperty(exports, "__esModule", { value: true });
const channel_1 = require("./channel");
const channelClientsByEndpointId = new Map();
class ChannelClient extends channel_1.ChannelBase {
    static closeChannelByEndpointId(id) {
        const channel = channelClientsByEndpointId.get(id);
        if (channel) {
            __classPrivateFieldGet(channel, _ChannelClient_close, "f").call(channel);
        }
    }
    // closes the corresponding channel and invokes the disconnect listener if an event payload is passed.
    static handleProviderDisconnect(eventPayload) {
        for (const channelClient of channelClientsByEndpointId.values()) {
            if (channelClient.providerIdentity.channelId === eventPayload.channelId) {
                channelClient.disconnectListener(eventPayload);
                __classPrivateFieldGet(channelClient, _ChannelClient_close, "f").call(channelClient);
            }
        }
    }
    constructor(routingInfo, wire, strategy) {
        super();
        _ChannelClient_protectedObj.set(this, void 0);
        _ChannelClient_strategy.set(this, void 0);
        // needs to be bound;
        this.processAction = (action, payload, senderIdentity) => super.processAction(action, payload, senderIdentity);
        _ChannelClient_close.set(this, () => {
            channelClientsByEndpointId.delete(this.endpointId);
            __classPrivateFieldGet(this, _ChannelClient_strategy, "f").close();
        });
        __classPrivateFieldSet(this, _ChannelClient_protectedObj, new channel_1.ProtectedItems(routingInfo, wire), "f");
        this.disconnectListener = () => undefined;
        this.endpointId = routingInfo.endpointId;
        __classPrivateFieldSet(this, _ChannelClient_strategy, strategy, "f");
        channelClientsByEndpointId.set(this.endpointId, this);
        strategy.receive(this.processAction);
    }
    get providerIdentity() {
        const protectedObj = __classPrivateFieldGet(this, _ChannelClient_protectedObj, "f");
        return protectedObj.providerIdentity;
    }
    async dispatch(action, payload) {
        if (__classPrivateFieldGet(this, _ChannelClient_strategy, "f").isEndpointConnected(this.providerIdentity.channelId)) {
            return __classPrivateFieldGet(this, _ChannelClient_strategy, "f").send(this.providerIdentity.channelId, action, payload);
        }
        throw new Error('The client you are trying to dispatch from is disconnected from the target provider.');
    }
    onDisconnection(listener) {
        this.disconnectListener = (payload) => {
            try {
                listener(payload);
            }
            catch (err) {
                throw new Error(`Error while calling the onDisconnection callback: ${err.message}`);
            }
            finally {
                this.disconnectListener = () => undefined;
            }
        };
    }
    async disconnect() {
        await this.sendDisconnectAction();
        __classPrivateFieldGet(this, _ChannelClient_close, "f").call(this);
    }
    async sendDisconnectAction() {
        const protectedObj = __classPrivateFieldGet(this, _ChannelClient_protectedObj, "f");
        const { channelName, uuid, name } = protectedObj.providerIdentity;
        await protectedObj.wire.sendAction('disconnect-from-channel', {
            channelName,
            uuid,
            name,
            endpointId: this.endpointId
        });
    }
}
exports.default = ChannelClient;
_ChannelClient_protectedObj = new WeakMap(), _ChannelClient_strategy = new WeakMap(), _ChannelClient_close = new WeakMap();
